<template>
  <div id="student-test-paper">
    <!-- 学生答卷具体情况界面 -->
    <!-- <div class="tip">仅看人工阅卷</div> -->
    <div class="type" v-for="(item, index) in data" :key="index">
      <div class="title">
        {{ transitionNumToText(index) }}、{{ transitionName(item.type) }}（{{
          item.item.length
        }}题 / {{ item.typeTotalPoints }}分）
      </div>
      <div class="item" v-for="(que, ii) in item.item" :key="ii">
        <div class="title">
          {{ que.index }}、<span v-html="que.questionStem"></span>
          <span class="nd"
            >（{{ que.points }} 分 难度：<i
              :class="{
                'el-icon-star-off': true,
                'el-icon-star-on': que.gradeOfDifficulty >= s,
              }"
              v-for="s in 5"
              :key="s"
            ></i>
            ）</span
          >
        </div>
        <div class="xx" v-if="item.type == '0' || item.type == '1'">
          <!-- 选择题的选项值 -->
          <div class="itel" v-for="(qo, iii) in que.questionOptions" :key="iii">
            {{ qo.title }}、<span v-html="qo.value"></span>
          </div>
        </div>
        <div class="da">
          <div class="line">
            <div class="title">【学员答案】:</div>
            <span v-if="item.type == '0' || item.type == '1'">
              <!-- 单选/多选 -->
              <span v-for="(an, iii) in que.answer" :key="iii">
                <span v-if="iii > 0">、</span>{{ an.value }}
              </span>
            </span>
            <div class="answer" v-if="item.type == '2'">
              <!-- 填空题 -->
              <span v-for="(an, iii) in que.answer" :key="iii" class="val">
                <span v-html="an.htmlValue"></span>
              </span>
            </div>
            <div class="answer" v-if="item.type == '3'">
              <!-- 判断题 -->
              <span v-for="(an, iii) in que.answer" :key="iii" class="val">
                <span
                  ><i class="el-icon-check" v-if="an.value == '0'"></i
                  ><i class="el-icon-close" v-else-if="an.value == '1'"></i
                  ><span v-else>无</span></span
                >
              </span>
            </div>
            <div class="answer" v-if="item.type == '4'">
              <!-- 简答题 -->
              <span v-for="(an, iii) in que.answer" :key="iii" class="val">
                <span v-html="an.htmlValue"></span>
              </span>
            </div>
          </div>
          <div class="line">
            <div class="title">【标准答案】:</div>
            <span v-for="(qua, iii) in que.questionAnswer" :key="iii">
              <span
                v-if="item.type != '1' && item.type != '3'"
                v-html="qua.value"
              ></span>
              <span v-else-if="item.type == '3'"
                ><i
                  :class="qua.value == '0' ? 'el-icon-check' : 'el-icon-close'"
                ></i></span
              ><span v-else>
                <span v-if="iii > 0">、</span> {{ qua.value }}
              </span>
            </span>
          </div>
          <div class="line">
            <div class="title">【评分】:</div>
            <div class="va">
              <el-input
                v-model="que.grade"
                placeholder="请输入分值"
                @change="changeGrade(que.grade, que.points, index, ii)"
              ></el-input>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as paperData1 from "../../views/admin/question_bank/js/question.js";
export default {
  name: "diy_dialog_paper",
  props: {
    paperData: {
      type: Array,
      default: function () {
        return [
          {
            type: "0", // 题目类型  0 单选  1 多选 2 填空  3 判断  4 简答
            typeTotalPoints: "20", // 当前类型下总分
            item: [
              {
                index: "1",
                questionStem: "", // 题干 含html
                questionOptions: [
                  // 选择题的选择项组
                  { title: "A", value: "AAAA" },
                  { title: "B", value: "BBBB" },
                ],
                gradeOfDifficulty: 3, // 难度等级  1 2 3 4 5
                points: "2", // 本题分值
                questionId: "",
                answer: "", // 学员答案
                questionAnswer: "", // 标准答案
                grade: "", // 本题得分值
              },
            ],
          },
          {
            type: "1", // 题目类型  0 单选  1 多选 2 填空  3 判断  4 简答
            typeTotalPoints: "20", // 当前类型下总分
            item: [
              {
                index: "1",
                questionStem: "", // 题干 含html
                questionOptions: [
                  // 选择题的选择项组
                  { title: "A", value: "AAAA" },
                  { title: "B", value: "BBBB" },
                ],
                gradeOfDifficulty: 3, // 难度等级  1 2 3 4 5
                points: "2", // 本题分值
                questionId: "",
                answer: "", // 学员答案
                questionAnswer: "", // 标准答案
                grade: "", // 本题得分值
              },
            ],
          },
          {
            type: "2", // 题目类型  0 单选  1 多选 2 填空  3 判断  4 简答
            typeTotalPoints: "20", // 当前类型下总分
            item: [
              {
                index: "1",
                questionStem: "", // 题干 含html
                questionOptions: [
                  // 选择题的选择项组
                  { title: "A", value: "AAAA" },
                  { title: "B", value: "BBBB" },
                ],
                gradeOfDifficulty: 3, // 难度等级  1 2 3 4 5
                points: "2", // 本题分值
                questionId: "",
                answer: "", // 学员答案
                questionAnswer: "", // 标准答案
                grade: "", // 本题得分值
              },
            ],
          },
          {
            type: "3", // 题目类型  0 单选  1 多选 2 填空  3 判断  4 简答
            typeTotalPoints: "20", // 当前类型下总分
            item: [
              {
                index: "1",
                questionStem: "", // 题干 含html
                questionOptions: [
                  // 选择题的选择项组
                  { title: "A", value: "AAAA" },
                  { title: "B", value: "BBBB" },
                ],
                gradeOfDifficulty: 3, // 难度等级  1 2 3 4 5
                points: "2", // 本题分值
                questionId: "",
                answer: "1", // 学员答案
                questionAnswer: "2", // 标准答案
                grade: "", // 本题得分值
              },
            ],
          },
          {
            type: "4", // 题目类型  0 单选  1 多选 2 填空  3 判断  4 简答
            typeTotalPoints: "20", // 当前类型下总分
            item: [
              {
                index: "1",
                questionStem: "", // 题干 含html
                questionOptions: [
                  // 选择题的选择项组
                  { title: "A", value: "AAAA" },
                  { title: "B", value: "BBBB" },
                ],
                gradeOfDifficulty: 3, // 难度等级  1 2 3 4 5
                points: "2", // 本题分值
                questionId: "",
                answer: "", // 学员答案
                questionAnswer: "", // 标准答案
                grade: "", // 本题得分值
              },
            ],
          },
        ];
      },
    },
  },
  data() {
    return {
      data: this.paperData,
      flag: true,
    };
  },
  watch: {
    paperData() {
      this.data = this.paperData;
    },
    data(newValue) {
      this.$emit("showPaper", this.data);
    },
  },
  methods: {
    /**
     * 小写数字转大写数字
     */
    transitionNumToText(num) {
      let text = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
      return text[num];
    },
    /**
     *
     */
    transitionName(type) {
      return paperData1.initTableValue("topic", type);
    },
    /**
     * 评分的判断
     * stuGrade : 阅卷老师打得分
     * queGrade : 当前题目的最高分
     * 1.判断当前打得分只能是数字
     * 2.判断当前打得分不能比当前题目的分值高
     */
    changeGrade(stuGrade, queGrade) {
      try {
        if (!this.$baseData.judgeStringIsNumber(stuGrade)) {
          throw "分值只能为数值型!";
        }
        if (stuGrade < 0) {
          throw "分值不能为负数!";
        }
        if (stuGrade > queGrade) {
          throw "最大分值为" + queGrade + "分";
        }
      } catch (error) {
        this.$message({
          message: error,
          type: "warning",
          duration: 1000,
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
#student-test-paper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  // background-color: #333;
  > .type {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    > .title {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-size: 16px;
      font-weight: bold;
    }
    > .item {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      border-bottom: 1px solid #cfcfcf;
      box-sizing: border-box;
      margin-bottom: 20px;
      padding-bottom: 10px;
      text-align: left;

      > .title {
        width: 100%;
        height: auto;
        line-height: 30px;
        display: flex;
        align-items: center;
        > .nd {
          margin-left: 10px;
          font-size: 14px;

          .el-icon-star-off {
            font-size: 15px;
            color: #e9e9e9;
          }
          .el-icon-star-on {
            color: #ffe710;
            font-size: 17px;
          }
        }
      }
      > .xx {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        box-sizing: border-box;
        > .itel {
          width: 100%;
          height: auto;
          line-height: 30px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin-bottom: 5px;
          font-size: 15px;
        }
      }
      > .da {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        > .line {
          width: 100%;
          height: 40px;
          display: flex;
          align-items: center;
          font-size: 15px;
          > .title {
            width: auto;
            margin-right: 5px;
            font-weight: bold;
          }
          > .va {
            width: 120px;
            margin-right: 10px;
            display: flex;
            font-size: 15px;
            align-items: center;
            > span {
              margin-left: 5px;
            }
          }
          > .answer {
            width: 0;
            flex: 1;
            height: auto;
            display: flex;
            flex-direction: column;
            > .val {
              width: 100%;
              line-height: 35px;
              height: auto;
              display: flex;
              justify-content: flex-start;
            }
          }
        }
      }
    }
  }
}
</style>